import { configureStore } from '@reduxjs/toolkit'
import cotizationReducer from './features/cotization/cotizationSlice'
import clientReducer from './features/clients/clientSlice'
import destinationReducer from './features/destinations/destinationSlice'
import reservationReducer from './features/reservations/reservationSlice'
import aerolineReducer from './features/aerolines/aerolineSlice'
import hotelReducer from './features/hotels/hotelSlice'
import tourReducer from './features/tours/tourSlice'
import authReducer from './features/auth/authSlice'
import operatorReducer from './features/operators/operatorSlice'
import accountingReducer from './features/accounting/accountingSlice'
import hotelConfigReducer from './features/hotelConfigurations/hotelConfigSlice'
import airlineConfigReducer from './features/airlineConfigurations/airlineConfigSlice'
import treasuryReducer from './features/treasury/treasurySlice'
import apOrdersReducer from './features/apOrders/apOrdersSlice'
import checkinReducer from './features/checkin/checkinSlice'
import cruiseCabinsReducer from './features/cruiseCabins/cruiseCabinsSlice'
import cruiseShipsReducer from './features/cruiseShips/cruiseShipsSlice'
import destinationTransfersReducer from './features/destinationTransfers/destinationTransferSlice'
import expensesReducer from './features/expenses/expensesSlice'
import { loadPersistedState, saveStateToStorage } from './util/reduxPersist'

// Hydrate from sessionStorage for instant content on page reload
const persistedState = loadPersistedState();

export const store = configureStore({
  reducer: {
    cotization: cotizationReducer,
    client: clientReducer,
    hotel: hotelReducer,
    aeroline: aerolineReducer,
    reservation: reservationReducer,
    destination: destinationReducer,
    tour: tourReducer,
    auth: authReducer,
    operator: operatorReducer,
    accounting: accountingReducer,
    hotelConfig: hotelConfigReducer,
    airlineConfig: airlineConfigReducer,
    treasury: treasuryReducer,
    apOrders: apOrdersReducer,
    checkin: checkinReducer,
    cruiseCabins: cruiseCabinsReducer,
    cruiseShips: cruiseShipsReducer,
    destinationTransfers: destinationTransfersReducer,
    expenses: expensesReducer,
  },
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoreActions: ['auth/setSession'],
      ignoredPaths: ['auth.session', 'auth.session.user']
    }
  }),
})

// Persist catalog data to sessionStorage on changes (debounced)
store.subscribe(() => {
  saveStateToStorage(store.getState());
});